import { DRILL_TYPE_INFORMATION } from "../../../containers/WorkSelect/constants/drill";
import { isWorkContents, isWorkSelection, isWorkTemplateContents, } from "../types/WorkTypes";
/**
 * ローマ字のドリルタイプ名から画面上に表示する文字列を返す
 * @param name ドリルタイプ名 ex) 'SANSU', 'KOKUGO'
 */
export var getDisplayValueFromName = function (name) {
    var _a, _b;
    return ((_b = (_a = Object.values(DRILL_TYPE_INFORMATION).find(function (drillTypeInfo) { return drillTypeInfo.name === name; })) === null || _a === void 0 ? void 0 : _a.displayValue) !== null && _b !== void 0 ? _b : undefined);
};
export function summarizeWorks(contents, maxDisplayWorks) {
    var selections;
    if (isWorkContents(contents)) {
        selections = contents.workSelections;
    }
    else if (isWorkTemplateContents(contents)) {
        selections = contents.workTemplates;
    }
    else {
        return [];
    }
    var lastDrillType;
    var displayWorks = selections.slice(0, maxDisplayWorks).map(function (selection) {
        var _a;
        // 同じドリルタイプが並んでいる場合は表示しない
        var shouldOmitDrillType = lastDrillType === selection.drillType;
        lastDrillType = selection.drillType;
        return {
            displayDrillType: shouldOmitDrillType ? '' : ((_a = getDisplayValueFromName(selection.drillType)) === null || _a === void 0 ? void 0 : _a.short) || '',
            workName: isWorkSelection(selection) ? selection.workName : selection.templateName,
            other: '',
        };
    });
    if (selections.length <= maxDisplayWorks) {
        return displayWorks;
    }
    // maxDisplayWorksに収まらない場合、最後の行は、残りのワークの合計を表示する。
    var otherWorks = selections.length - (maxDisplayWorks - 1);
    return displayWorks
        .slice(0, maxDisplayWorks - 1)
        .concat({ displayDrillType: '他', workName: '', other: "(" + otherWorks + ")" });
}
